export enum StatusCode {
  success = 200,
  expired = 40020,
  authCodeExpired = 'empty',
  touristToStaff = 70002,
  staffToTourist = 70001,
  IM_CONVERSATION_EXISTED = 40051,
  ILLEGAL_ACCESS = 510300 // 业务未开通
}
